import React, { Component, useState, useEffect, useRef } from 'react';
import { Button, Table, Input, Form, FormFeedback, FormGroup, FormText } from 'reactstrap';
import moment from "moment";
import { useDispatch, useSelector } from 'react-redux';

const IndiSaltoClass = (props) => {
    const dispatch = useDispatch()
    const selectAuthToken = state => state.apiKey
    const selectStore = state => state
    const authToken = useSelector(selectAuthToken);
    const reduxData = useSelector(selectStore);
    const [tableData, setTableData] = useState([])
    const [eventData, setEventData] = useState([])
    const [sectionData, setSectionData] = useState([])
    const [subtypeData, setSubtypeData] = useState([])
    const [saltoData, setSaltoData] = useState([])
    const [formActive, setFormActive] = useState({
        term: "DEFAULT",
        year: "DEFAULT",
        session: "DEFAULT",
        eventid: "DEFAULT",
        section: "DEFAULT",
        subtype: "DEFAULT",
        salto: "DEFAULT"
    })
    const generateArray = (aroundNumber) => [...Array(11).keys()].map(i => i + aroundNumber - 4);

    useEffect(() => {
        getTableInfo();
        getFormData();
    }, [])

    function getTableInfo() {
        let bearerVAR = "Bearer " + authToken
        dispatch({ type: 'foundation/setFetchTime' })
        let toSend = {
            userLevel: reduxData.userInfo.level.pk
        }
        fetch('IndiSaltoClassGetData', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
            .then((response) => response.json())
            .then((responseJSON) => setTableData(responseJSON))
    }

    function getFormData() {
        let bearerVAR = "Bearer " + authToken
        dispatch({ type: 'foundation/setFetchTime' })
        let toSend = {
            userLevel: reduxData.userInfo.level.pk
        }
        fetch('IndiSaltoClassGetFormInfo', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
            .then((response) => response.json())
            .then((responseJSON) => {
                setEventData(responseJSON.eventid)
                setSectionData(responseJSON.section)
                setSubtypeData(responseJSON.subtype)
                setSaltoData(responseJSON.saltogroup)
            })
    }

    const manageFormChange = (e, field) => {
        let newState = {}
        switch (field) {
            case "term":
                newState = {
                    ...formActive,
                    term: e
                }
                setFormActive(newState)
                return "";
            case "year":
                newState = {
                    ...formActive,
                    year: e
                }
                setFormActive(newState)
                return "";
            case "session":
                newState = {
                    ...formActive,
                    session: e
                }
                setFormActive(newState)
                return "";
            case "event":
                newState = {
                    ...formActive,
                    eventid: e
                }
                setFormActive(newState)
                return "";
            case "section":
                newState = {
                    ...formActive,
                    section: e
                }
                setFormActive(newState)
                return "";
            case "subtype":
                newState = {
                    ...formActive,
                    subtype: e
                }
                setFormActive(newState)
                return "";
            case "salto":
                newState = {
                    ...formActive,
                    salto: e
                }
                setFormActive(newState)
                return "";
            default:
                return "";
        }
    }

    function submitForm() {
        let bearerVAR = "Bearer " + authToken
        dispatch({ type: 'foundation/setFetchTime' })
        let toSend = {
            ...formActive,
            userLevel: reduxData.userInfo.level.pk
        }
            fetch('IndiSaltoClassAddNew', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
            .then((response) => response.json())
                .then((responseJSON) => {
                    getTableInfo()
                    setFormActive({
                        term: "DEFAULT",
                        year: "DEFAULT",
                        session: "DEFAULT",
                        eventid: "DEFAULT",
                        section: "DEFAULT",
                        subtype: "DEFAULT",
                        salto: "DEFAULT"
                    })
                })
    }

    function deleteRecord(item) {
        let bearerVAR = "Bearer " + authToken 
        dispatch({ type: 'foundation/setFetchTime' })
        let toSend = {
            pk: item,
            userLevel: reduxData.userInfo.level.pk
        }
        fetch('IndiSaltoClassDelete', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
            .then((response) => response.json())
            .then((responseJSON) => getTableInfo())
    }

    return (<div>
        <h3>Course</h3>
        <br />
        <Form className="d-flex">
            <FormGroup>
                <Input type="select" id="termClass" name="termClass" value={formActive.term } onChange={(e) => manageFormChange(e.target.value, "term") }>
                    <option disabled value="DEFAULT">Select Term</option>
                    <option>Any</option>
                    <option>WINTER</option>
                    <option>SPRING</option>
                    <option>SUMMERI</option>
                    <option>SUMMERII</option>
                    <option>FALL</option>
                </Input>
            </FormGroup>
            &nbsp;
            <FormGroup>
                <Input type="select" id="yearClass" name="yearClass" value={formActive.year} onChange={(e) => manageFormChange(e.target.value, "year") }>
                    <option disabled value="DEFAULT">Select Year</option>
                    <option>Any</option>
                    {generateArray(new Date().getFullYear()).map(item => (
                        <option>{item}</option>
                    )) }
                </Input>
            </FormGroup>
            &nbsp;
            <FormGroup>
                <Input type="select" id="sessionClass" name="sessionClass" value={formActive.session} onChange={(e) => manageFormChange(e.target.value,"session")}>
                    <option disabled value="DEFAULT">Select Session</option>
                    <option>Any</option>
                    <option>01</option>
                </Input>
            </FormGroup>
            &nbsp;
            <FormGroup>
                <Input type="select" id="eventClass" name="eventClass" value={formActive.eventid} onChange={(e) => manageFormChange(e.target.value, "event")}>
                    <option disabled value="DEFAULT">Select Event</option>
                    {eventData.map(item => (
                        <option>{item}</option>
                    ))}
                </Input>
            </FormGroup>
            &nbsp;
            <FormGroup>
                <Input type="select" id="subtypeClass" name="subtypeClass" value={formActive.subtype} onChange={(e) => manageFormChange(e.target.value, "subtype")}>
                    <option disabled value="DEFAULT">Select Subtype</option>
                    <option>Any</option>
                    {subtypeData.map(item => (
                        <option>{item}</option>
                    ))}
                </Input>
            </FormGroup>
            &nbsp;
            <FormGroup>
                <Input type="select" id="sectionClass" name="sectionClass" value={formActive.section} onChange={(e) => manageFormChange(e.target.value, "section")}>
                    <option disabled value="DEFAULT">Select Section</option>
                    <option>Any</option>
                    {sectionData.map(item => (
                        <option>{item}</option>
                    ))}
                </Input>
            </FormGroup>
            &nbsp;
            <FormGroup>
                <Input type="select" id="saltoClass" name="saltoClass" value={formActive.salto} onChange={(e) => manageFormChange(e.target.value, "salto")}>
                    <option disabled value="DEFAULT">Select Salto Group</option>
                    {saltoData.map(item => (
                        <option>{item}</option>
                    )) }
                </Input>
            </FormGroup>
            &nbsp;
            {formActive.term != "DEFAULT" &&
                formActive.year != "DEFAULT" &&
                formActive.session != "DEFAULT" &&
                formActive.eventid != "DEFAULT" &&
                formActive.section != "DEFAULT" &&
                formActive.subtype != "DEFAULT" &&
                formActive.salto != "DEFAULT" &&
                <Button onClick={() => submitForm() }>Add</Button>}
        </Form>
        <br />
        {tableData.length > 0 && <Table>
            <thead>
                <tr>
                    <th>Term</th>
                    <th>Year</th>
                    <th>Session</th>
                    <th>Event ID</th>
                    <th>Subtype</th>
                    <th>Section</th>
                    <th>Salto Group</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {tableData.map(item => (
                    <tr>
                        <td>{item.term}</td>
                        <td>{item.year}</td>
                        <td>{item.session}</td>
                        <td>{item.eventid}</td>
                        <td>{item.subtype}</td>
                        <td>{item.section}</td>
                        <td>{item.saltogroup}</td>
                        <td><Button outline color="danger" onClick={() => deleteRecord(item.pk) }>Delete</Button></td>
                    </tr>
                )) }
            </tbody>
        </Table>}
    </div>)
}

export default IndiSaltoClass;